if (!customElements.get('gift-finder')) {
  class GiftFinder extends HTMLElement {
    connectedCallback() {
      this.cardTemplate = this.querySelector('.js-gf-card-template');
      this.itemTemplate = this.querySelector('.js-gf-item-template');
      this.products = GiftFinder.parseProducts(this.querySelector('.js-gf-products'));
      if (!this.cardTemplate || this.products.length === 0) return;

      this.cards = [];

      this.cardWrap = this.querySelector('.js-gf-cards');
      this.extras = this.querySelector('.js-gf-extras');
      this.budgetHint = this.querySelector('.js-gf-budget-hint');
      this.altsTitle = this.querySelector('.js-gf-alts-title');
      this.far = this.querySelector('.js-gf-far');
      this.slider = this.querySelector('.js-gf-slider');
      this.amount = this.querySelector('.js-gf-amount');
      this.error = this.querySelector('.js-gf-error');
      this.wrapToggle = this.querySelector('.js-gf-wrap');
      this.wrapNote = this.querySelector('.js-gf-note');

      this.budget = Number(this.slider ? this.slider.value : 50);
      this.chosen = null;

      // Elke vraag is een <details> met een data-q; het ingedrukte antwoord is het huidige.
      this.steps = Array.from(this.querySelectorAll('.gf-step[data-q]'));
      // Niets staat voorgeselecteerd: een antwoord is er pas als de bezoeker het geeft.
      // Zolang een vraag open staat gebruikt de samensteller er simpelweg geen filter op.
      this.answers = {};

      // Wordt de printtag ergens gebruikt? Zo ja, dan is de woordenlijst niet meer nodig.
      const printTag = (this.dataset.printTag || '').toLowerCase();
      this.printTagInGebruik = Boolean(printTag) && this.products
        .some((p) => p.tags.some((t) => t.toLowerCase() === printTag));

      this.buildTypes();
      this.buildChoiceImages();
      this.addEventListener('click', this.handleClick.bind(this));

      if (this.wrapToggle) {
        this.wrapToggle.addEventListener('change', () => {
          if (this.wrapNote) this.wrapNote.hidden = !this.wrapOn();
          this.render();
        });
      }


      if (this.slider) {
        this.slider.addEventListener('input', () => {
          this.budget = Number(this.slider.value);
          this.chosen = null;
          const sliderHint = this.querySelector('.js-gf-slider-hint');
          if (sliderHint) sliderHint.hidden = false;
          this.render();
        });
      }


      this.render();
    }

    /**
     * Handles clicks on the answer chips, the colour groups and the buttons on a package.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      const modus = evt.target.closest('.js-gf-mode [data-mode]');
      if (modus) {
        const groep = modus.closest('.js-gf-mode');
        const stapSoorten = modus.closest('.gf-step');
        if (stapSoorten) stapSoorten.classList.add('is-answered');
        groep.querySelectorAll('[data-mode]').forEach((el) => el.setAttribute('aria-pressed', 'false'));
        modus.setAttribute('aria-pressed', 'true');

        const zelf = modus.dataset.mode === 'self';
        const paneel = this.querySelector('.js-gf-types-panel');
        if (paneel) paneel.hidden = !zelf;

        // Terug naar laten uitzoeken betekent ook: de aangevinkte categorieën vergeten,
        // anders werkt er een keuze door die niet meer op het scherm staat.
        if (!zelf) {
          this.querySelectorAll('.js-gf-types-grid [data-type]')
            .forEach((el) => el.setAttribute('aria-pressed', 'false'));
          this.answers.soorten = [];
        }

        this.toonSoorten();
        this.chosen = null;
        this.render();
        return;
      }

      const soort = evt.target.closest('.js-gf-types [data-type]');
      if (soort) {
        const aan = soort.getAttribute('aria-pressed') === 'true';
        soort.setAttribute('aria-pressed', String(!aan));

        this.answers.soorten = Array.from(this.querySelectorAll('.js-gf-types-grid [data-type]'))
          .filter((el) => el.getAttribute('aria-pressed') === 'true')
          .map((el) => el.dataset.type);

        this.toonSoorten();

        this.chosen = null;
        this.render();
        return;
      }

      const answer = evt.target.closest('.gf-step[data-q] [data-v]');
      if (answer) {
        const step = answer.closest('.gf-step[data-q]');
        step.querySelectorAll('[data-v]').forEach((el) => el.setAttribute('aria-pressed', 'false'));
        answer.setAttribute('aria-pressed', 'true');
        this.answers[step.dataset.q] = answer.dataset.v;
        step.classList.add('is-answered');
        if (step.dataset.q === 'when') {
          this.querySelectorAll('.js-gf-item').forEach((item) => { delete item.dataset.chosen; });
        }
        GiftFinder.showAnswer(step, answer);

        // Eén antwoord mag het bedrag wel verzetten: geven met een groepje betekent
        // nu eenmaal een ander bedrag. De schuif blijft daarna van de bezoeker.
        if (answer.dataset.amount && this.slider) {
          this.budget = Number(answer.dataset.amount);
          this.slider.value = this.budget;
        }

        this.chosen = null;
        this.render();

        // Pas doorschuiven nadat het voorstel opnieuw is opgebouwd: dat verandert de
        // hoogte van de pagina, en een scroll die daarvóór begint wordt teruggezet.
        // Een timeout en geen requestAnimationFrame, want die staat stil in een tabblad
        // dat op de achtergrond draait.
        setTimeout(() => this.advance(step), 50);
        return;
      }

      const sizeBtn = evt.target.closest('.js-gf-item-sizes [data-variant]');
      if (sizeBtn) {
        const rij = sizeBtn.closest('.js-gf-item');
        rij.querySelectorAll('[data-variant]').forEach((el) => el.setAttribute('aria-pressed', 'false'));
        sizeBtn.setAttribute('aria-pressed', 'true');
        rij.dataset.chosen = sizeBtn.dataset.variant;
        this.applySizes();
        return;
      }

      const pick = evt.target.closest('.js-gf-pick');
      if (pick) {
        const card = pick.closest('.js-gf-card');
        this.chosen = card.dataset.name;
        this.render();

        // Zonder dit lijkt er niets te gebeuren: het pakket dat je aanklikt wisselt van
        // plek naar boven, en dat zie je niet als je onderaan staat te kijken.
        const main = this.querySelector('.gf-card.is-main');
        if (main) {
          main.scrollIntoView({ behavior: 'smooth', block: 'center' });
          main.classList.remove('is-swapped');
          void main.offsetWidth;
          main.classList.add('is-swapped');
        }
        return;
      }

      const addBtn = evt.target.closest('.js-gf-add');
      if (addBtn) {
        evt.preventDefault();
        this.addPackage(addBtn);
      }
    }

    /**
     * Puts the closest match on top and the rest below it as alternatives. Runs on every
     * change, so there is always a suggestion on screen and never an empty result page.
     */
    render() {
      if (this.amount) this.amount.textContent = GiftFinder.money(this.budget * 100, false);

      if (this.slider) {
        const min = Number(this.slider.min) || 0;
        const max = Number(this.slider.max) || 100;
        const pct = ((this.budget - min) / Math.max(max - min, 1)) * 100;
        this.slider.style.setProperty('--gf-fill', `${pct}%`);
      }

      // Het richtbedrag onder de schuif komt uit dezelfde instelling als de sprong die
      // de schuif maakt, zodat de tekst nooit iets anders zegt dan waar de schuif staat.
      if (this.budgetHint) {
        // Zonder antwoord op alleen of samen: uitgaan van alleen, dat is het gewone geval.
        const samen = this.answers.group === 'together';
        const knop = this.querySelector(`.gf-step[data-q="group"] [data-v="${samen ? 'together' : 'alone'}"]`);
        const bedrag = knop ? Number(knop.dataset.amount) : 0;
        const regel = samen ? this.budgetHint.dataset.together : this.budgetHint.dataset.alone;
        this.budgetHint.textContent = (regel || '').replace('{bedrag}', GiftFinder.money(bedrag * 100, false));
      }

      const cents = this.budget * 100;

      // Het opnieuw opbouwen van de kaarten verandert de hoogte van de pagina, en de
      // browser schuift dan mee. Zonder dit springt het scherm bij elke aangevinkte
      // categorie een stukje weg onder je handen.
      const scrollVoor = window.scrollY;

      // Het bedrag is een grens, geen voorkeur: wie 195 euro wil uitgeven hoort geen
      // pakket van 61 te zien. De samensteller mikt op het bedrag; wat er daarna nog
      // ver naast zit, is wat de voorraad toelaat.
      const voorstellen = this.stelSamen(cents, 3);
      this.buiten = voorstellen.length === 0
        || Math.abs(voorstellen[0].totaal - cents) > cents * 0.25;

      this.cardWrap.querySelectorAll('.js-gf-card').forEach((el) => el.remove());
      this.cards = voorstellen.map((pakket) => this.maakKaart(pakket));

      if (this.cards.length === 0) {
        if (this.altsTitle) this.altsTitle.hidden = true;
        return;
      }

      let main = this.cards[0];
      if (this.chosen) {
        const picked = this.cards.find((card) => card.dataset.name === this.chosen);
        if (picked) main = picked;
      }

      this.cards.forEach((card) => card.classList.toggle('is-main', card === main));

      if (this.altsTitle) this.altsTitle.hidden = this.cards.length < 2;

      // De keuzes over de bestelling horen bij het pakket dat je koopt, dus ze verhuizen
      // mee naar de kaart die bovenaan staat. Eén keer in de HTML, niet bij elk pakket.
      if (this.extras) {
        const slot = main.querySelector('.js-gf-extras-slot');
        if (slot && this.extras.parentElement !== slot) slot.appendChild(this.extras);
      }

      // De alternatieven horen onder de koopknop van het voorstel, dus binnen dezelfde
      // kaart. Ze verhuizen mee als er een ander pakket bovenaan komt te staan.
      const altSlot = main.querySelector('.js-gf-alts-slot');
      if (altSlot) {
        altSlot.appendChild(this.altsTitle);
        this.cards.forEach((card) => {
          if (card !== main) altSlot.appendChild(card);
        });
      }

      // Zeg het hardop wanneer er niets in de buurt van het bedrag stond.
      if (this.far) this.far.hidden = !this.buiten;

      if (Math.abs(window.scrollY - scrollVoor) > 1) window.scrollTo(0, scrollVoor);

      this.buildSizes(main);

      const wrapPrice = this.wrapOn() ? Number(this.dataset.wrapPrice || 0) : 0;
      this.cards.forEach((card) => {
        const line = card.querySelector('.js-gf-wrap-line');
        const total = card.querySelector('.js-gf-total');
        if (line) line.hidden = !this.wrapOn() || card !== main;
        if (total) total.textContent = GiftFinder.money(Number(total.dataset.base) + wrapPrice);
      });
    }

    /**
     * Puts the chosen answer in the closed summary line, so a folded step still shows
     * what was picked.
     * @param {Element} step - The question.
     * @param {Element} answer - The chosen button.
     */
    static showAnswer(step, answer) {
      const slot = step.querySelector('.js-gf-answer');
      if (!slot) return;

      // Een vraag die de bezoeker nog niet aanraakte laat niets zien: wat daar staat is
      // een aanname van de winkel en geen antwoord van hem.
      slot.textContent = step.classList.contains('is-answered')
        ? (answer.textContent || '').trim()
        : '';
    }

    /**
     * Folds the answered question and opens the next one, so the visitor is led through
     * the questions one at a time instead of meeting all six at once.
     * @param {Element} step - The question that was just answered.
     */
    advance(step) {
      const i = this.steps.indexOf(step);
      if (i === -1) return;

      const next = this.steps[i + 1];
      if (next) {
        step.open = false;
        next.open = true;
      }

      // Meelopen met de bezoeker: na een antwoord staat de volgende vraag in beeld, en
      // na de laatste het bedrag waar het voorstel aan hangt.
      const doel = next || this.querySelector('.gf-step--budget');
      if (!doel) return;

      // Zelf rekenen in plaats van scrollIntoView: de meelopende koptekst van de winkel
      // is bijna honderdtwintig pixels hoog, en een vraag die daar precies achter
      // schuift is niet doorgeschoven maar verdwenen.
      const rustig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const top = Math.max(doel.getBoundingClientRect().top + window.scrollY - 120, 0);
      const begin = window.scrollY;

      window.scrollTo({ top, behavior: rustig ? 'auto' : 'smooth' });

      // Niet elke omgeving voert een vloeiende scroll uit. Staat de pagina even later nog
      // stil, dan springt hij alsnog: bij de volgende vraag komen is belangrijker dan hoe
      // hij daar komt.
      if (rustig) return;
      setTimeout(() => {
        if (Math.abs(window.scrollY - begin) < 2 && Math.abs(top - begin) > 2) {
          window.scrollTo(0, top);
        }
      }, 250);
    }

    /**
     * Leest de voorraad die de sectie meegeeft. Eén regel per product, velden gescheiden
     * door ^ en producten door §, want JSON in Liquid met aanhalingstekens in
     * producttitels gaat vroeg of laat stuk.
     * @param {Element} node - Script element with the data.
     * @returns {Array}
     */
    static parseProducts(node) {
      if (!node) return [];

      return node.textContent
        .split('§')
        .map((regel) => regel.trim())
        .filter(Boolean)
        .map((regel) => {
          const [bron, id, titel, url, img, type, tags, sfeer, print, varianten] = regel.split('^');
          const vs = (varianten || '')
            .split('|')
            .filter(Boolean)
            .map((deel) => {
              const [size, vid, price, ok] = deel.split('~');
              return {
                size, id: Number(vid), price: Number(price), available: ok !== '0', nummer: parseInt(size, 10) || 0
              };
            });
          const koopbaar = vs.filter((v) => v.available);

          return {
            bron,
            id: Number(id),
            titel,
            url,
            img,
            type: type || '',
            tags: (tags || '').split(',').map((t) => t.trim()).filter(Boolean),
            sfeer: (sfeer || '').trim(),
            print: (print || '').trim(),
            varianten: vs,
            prijs: koopbaar.length > 0 ? Math.min(...koopbaar.map((v) => v.price)) : 0
          };
        })
        .filter((p) => p.varianten.some((v) => v.available));
    }

    /**
     * Zet in de dichtgeklapte regel wat er gekozen is: of de winkel het uitzoekt, of de
     * categorieën die aangevinkt staan.
     */
    toonSoorten() {
      const stap = this.querySelector('.gf-step[data-q="soorten"]');
      const slot = stap ? stap.querySelector('.js-gf-answer') : null;
      if (!slot) return;

      if (!stap.classList.contains('is-answered')) {
        slot.textContent = '';
        return;
      }

      const zelf = this.querySelector('.js-gf-mode [data-mode="self"][aria-pressed="true"]');
      const gekozen = this.answers.soorten || [];

      if (!zelf) {
        slot.textContent = this.dataset.typesAuto || '';
        return;
      }

      slot.textContent = gekozen.length > 0 ? gekozen.join(', ') : (this.dataset.typesSelf || '');
    }

    /**
     * De antwoorden op de twee foto-vragen krijgen een echt product als beeld. Welk
     * product dat is hangt af van de voorraad, dus dat kan hier niet in de sjabloon
     * vastliggen. Staat er in de sectie-instellingen al een eigen foto bij een antwoord,
     * dan blijft die staan (die draagt data-vast). Levert een antwoord geen enkel passend
     * product op, dan verdwijnt het beeld en blijft de knop over met alleen zijn tekst.
     */
    buildChoiceImages() {
      // Duurste eerst: dat is meestal het stuk waar de foto het mooist van is.
      const opAflopendePrijs = (test) => this.products
        .filter((p) => p.img && test(p))
        .sort((a, b) => b.prijs - a.prijs);

      const kiezers = {
        clothing: () => opAflopendePrijs((p) => p.bron === 'clothing' && !this.isPrint(p)),
        nights: () => opAflopendePrijs((p) => p.bron === 'nights'),
        complete: () => opAflopendePrijs((p) => p.bron === 'clothing' || p.bron === 'nights'),
        plain: () => opAflopendePrijs((p) => !this.isPrint(p)),
        // Een printje erbij is een accent, geen hele garderobe: daarom eerst de kleinere
        // stukken met een printje, zodat dit antwoord er anders uitziet dan het volgende.
        accent: () => opAflopendePrijs((p) => this.isPrint(p) && p.prijs < 4000)
          .concat(opAflopendePrijs((p) => this.isPrint(p))),
        print: () => opAflopendePrijs((p) => this.isPrint(p))
      };

      // Twee antwoorden naast elkaar met dezelfde foto helpen niemand kiezen, dus elk
      // beeld komt maar één keer voor en de rest schuift een plek op.
      const gebruikt = new Set();

      this.querySelectorAll('.gf-photo[data-v]').forEach((knop) => {
        const img = knop.querySelector('.js-gf-choice-img');
        if (!img) return;
        if (img.dataset.vast === '1') {
          gebruikt.add(img.getAttribute('src'));
          return;
        }

        const kies = kiezers[knop.dataset.v];
        const lijst = kies ? kies() : [];
        const gekozen = lijst.find((p) => !gebruikt.has(p.img));
        if (!gekozen) {
          img.remove();
          return;
        }
        gebruikt.add(gekozen.img);
        img.src = gekozen.img;
        img.alt = '';
      });
    }

    /**
     * Zet de soorten die in de collecties zitten als aanvinkbare knoppen neer. Niets
     * aangevinkt betekent: kies jij maar, en dan doet alles mee.
     */
    buildTypes() {
      const slot = this.querySelector('.js-gf-types-grid');
      if (!slot) return;

      // Elke categorie krijgt het beeld van een product uit die categorie: het duurste,
      // want dat is meestal het stuk waar de foto het mooist van is.
      const perSoort = new Map();
      this.products.forEach((p) => {
        if (!p.type) return;
        const staat = perSoort.get(p.type);
        if (!staat || p.prijs > staat.prijs) perSoort.set(p.type, p);
      });

      const soorten = Array.from(perSoort.keys()).sort((a, b) => a.localeCompare(b, 'nl'));

      this.answers.soorten = [];

      soorten.forEach((soort) => {
        const tegel = document.createElement('button');
        tegel.type = 'button';
        tegel.className = 'gf-type';
        tegel.dataset.type = soort;
        tegel.setAttribute('aria-pressed', 'false');
        tegel.innerHTML = `<span class="gf-type__box" aria-hidden="true">`
          + `<svg width="12" height="12" viewBox="0 0 12 12" fill="none">`
          + `<path d="M2.5 6.2L4.8 8.5L9.5 3.8" stroke="currentColor" stroke-width="1.8"`
          + ` stroke-linecap="round" stroke-linejoin="round"/></svg></span>`
          + `<img class="gf-type__icon" src="${perSoort.get(soort).img}" alt="" loading="lazy">`
          + `<span class="gf-type__label"></span>`;
        tegel.querySelector('.gf-type__label').textContent = soort;
        slot.appendChild(tegel);
      });

      this.toonSoorten();
    }

    /**
     * Draagt dit product een print? Op het woord in de titel, want dat is waar deze
     * winkel haar prints benoemt: Rabbits, Zebra, Garden Flowers, Little Hearts. Op
     * "geen herkenbare kleur" afgaan werkt niet, want in Hoeslaken Flowers Cacao staat
     * een kleur én een print.
     * @param {object} product - Product.
     * @returns {boolean}
     */
    isPrint(product) {
      // Het metafield Print gaat voor: true of false is een antwoord, leeg betekent dat
      // er nog niets is ingevuld en dan tellen de tag en de titel.
      if (product.print === 'true') return true;
      if (product.print === 'false') return false;

      const tag = (this.dataset.printTag || '').toLowerCase();
      if (tag) {
        const tags = product.tags.map((t) => t.toLowerCase());
        if (tags.includes(tag)) return true;
        // Draagt een ander product wél die tag, dan wordt hij blijkbaar gebruikt en
        // betekent het ontbreken ervan: geen print.
        if (this.printTagInGebruik) return false;
      }

      const titel = product.titel.toLowerCase();
      const prints = ['heart', 'flower', 'rabbit', 'zebra', 'leopard', 'moon', 'star',
        'safari', 'monkey', 'blueberr', 'daisy', 'panther', 'dots', 'confetti', 'bloem',
        'olive branch', 'driehoek', 'pijltjes', 'jeans'];
      return prints.some((woord) => titel.includes(woord));
    }

    /**
     * De sfeer van een product. Staat er een tag met het ingestelde voorvoegsel, dan is
     * dat de sfeer. Zo niet, dan wordt de kleur uit de titel gelezen, want die staat bij
     * deze winkel bijna altijd achteraan.
     * @param {object} product - Product.
     * @returns {string}
     */
    moodOf(product) {
      // Het metafield is de bron: dat vult Shumei in de admin en groeit dus mee met
      // nieuwe kleuren. Staat het leeg, dan valt hij terug op een tag en anders op het
      // woord in de titel.
      if (product.sfeer) return product.sfeer.toLowerCase();

      const prefix = (this.dataset.moodTag || '').toLowerCase();
      if (prefix) {
        const tag = product.tags.find((t) => t.toLowerCase().startsWith(prefix));
        if (tag) return tag.slice(prefix.length).toLowerCase();
      }

      const staart = (product.titel.split(' - ').pop() || '').toLowerCase();
      const families = {
        roze: ['pink', 'mauve', 'peach', 'lila', 'purple', 'blush', 'roze'],
        koel: ['blue', 'petrol', 'sage', 'olive', 'grey', 'grijs', 'blueberries', 'denim'],
        naturel: ['ecru', 'sand', 'beige', 'taupe', 'ivory', 'natural', 'cacao', 'camel',
          'oatmeal', 'milk', 'cream', 'brown', 'linen', 'clay', 'stone', 'nude']
      };

      return Object.keys(families)
        .find((fam) => families[fam].some((woord) => staart.includes(woord))) || '';
    }

    /**
     * Welke producten mogen mee, gegeven de antwoorden. Meisjes- en jongensitems sluiten
     * elkaar uit; alles zonder zo'n tag doet overal mee.
     * @returns {Array}
     */
    kandidaten() {
      const girl = (this.dataset.girlTag || '').toLowerCase();
      const boy = (this.dataset.boyTag || '').toLowerCase();
      const wil = this.answers.audience;

      const lijst = this.products.filter((p) => {
        const tags = p.tags.map((t) => t.toLowerCase());
        const isGirl = girl && tags.includes(girl);
        const isBoy = boy && tags.includes(boy);

        if (wil === 'girl' && isBoy) return false;
        if (wil === 'boy' && isGirl) return false;
        if (wil === 'neutral' && (isGirl || isBoy)) return false;

        // Aangevinkte soorten zijn een voorkeur: staat er niets aan, dan doet alles mee.
        // Een product zonder soort kan niet aangevinkt worden en valt dus ook buiten een
        // selectie, anders komt het overal in terecht.
        const keuze = this.answers.soorten || [];
        if (keuze.length > 0 && !keuze.includes(p.type)) return false;

        if (this.answers.style) {
          const print = this.isPrint(p);
          if (this.answers.style === 'print' && !print) return false;
          if (this.answers.style === 'plain' && print) return false;
        }

        return true;
      });

      // Een aangevinkte soort die door het antwoord op meisje of jongen helemaal wegvalt,
      // komt alsnog terug. Wie om een bodysuit vraagt en er bestaan er alleen twee met
      // een meisjestag, hoort die te zien in plaats van geen voorstel te krijgen.
      (this.answers.soorten || []).forEach((type) => {
        if (lijst.some((p) => p.type === type)) return;
        this.products.filter((p) => p.type === type).forEach((p) => lijst.push(p));
      });

      return lijst;
    }

    /**
     * Stelt pakketten samen tot het bedrag gevuld is. Het recept volgt uit wat voor
     * cadeau de bezoeker wil, en er wordt alleen binnen één sfeer gecombineerd zodat er
     * geen roze haarband bij een blauw boxpakje belandt.
     * @param {number} cents - Budget in cents.
     * @param {number} hoeveel - How many packages to build.
     * @returns {Array}
     */
    stelSamen(cents, hoeveel) {
      const recepten = {
        clothing: ['clothing', 'clothing', 'extras'],
        nights: ['nights', 'nights', 'extras'],
        complete: ['nights', 'clothing', 'extras', 'clothing'],
        // Nog geen antwoord op wat voor cadeau: dan een pakket met van alles wat.
        onbekend: ['clothing', 'nights', 'extras', 'clothing']
      };
      // Heeft de bezoeker soorten aangevinkt, dan is dat het recept: van elke soort één,
      // in die volgorde. Anders bepaalt het soort cadeau wat er in het pakket komt.
      const keuze = this.answers.soorten || [];
      const recept = keuze.length > 0
        ? keuze.map((type) => ({ verplicht: true, test: (p) => p.type === type }))
        : (recepten[this.answers.kind] || recepten.onbekend)
          .map((bron) => ({ verplicht: false, test: (p) => p.bron === bron }));

      const perSfeer = {};
      this.kandidaten().forEach((p) => {
        const sfeer = this.moodOf(p) || 'overig';
        if (!perSfeer[sfeer]) perSfeer[sfeer] = [];
        perSfeer[sfeer].push(p);
      });

      const pakketten = [];
      const gezien = new Set();

      Object.keys(perSfeer).forEach((sfeer) => {
        const gebouwd = this.bouw(perSfeer[sfeer], recept, cents);
        if (!gebouwd) return;

        const sleutel = gebouwd.items.map((i) => i.id).sort().join('-');
        if (gezien.has(sleutel)) return;
        gezien.add(sleutel);
        pakketten.push(gebouwd);
      });

      // Vindt geen enkele sfeer een pakket waar alles in zit wat de bezoeker vroeg, dan
      // laat de sfeer het afweten en niet de vraag: opnieuw proberen zonder die grens.
      if (pakketten.length === 0) {
        const breed = this.bouw(this.kandidaten(), recept, cents);
        if (breed) pakketten.push(breed);
      }

      // Nog steeds niets, bijvoorbeeld omdat er van de gevraagde soort niets met een
      // printje is: dan liever een voorstel zonder die stijl dan een leeg scherm.
      if (pakketten.length === 0 && this.answers.style) {
        const stijl = this.answers.style;
        delete this.answers.style;
        const zonder = this.bouw(this.kandidaten(), recept, cents);
        this.answers.style = stijl;
        if (zonder) pakketten.push(zonder);
      }

      return pakketten
        .sort((a, b) => Math.abs(a.totaal - cents) - Math.abs(b.totaal - cents))
        .slice(0, hoeveel);
    }

    /**
     * Bouwt één pakket uit een groep producten. Het recept geeft de volgorde aan en
     * herhaalt zich zolang er budget over is, want een cadeau van tweehonderd euro
     * bestaat uit meer stukken dan een van dertig. Stopt zodra het totaal in de buurt van
     * het bedrag komt of er niets meer bij past.
     * @param {Array} groep - Products of one look.
     * @param {Array} recept - Which kind of product per step.
     * @param {number} cents - Budget in cents.
     * @returns {object|null}
     */
    bouw(groep, recept, cents) {
      const items = [];
      const gebruikt = new Set();
      const maxItems = 8;
      let totaal = 0;

      for (let stap = 0; stap < maxItems; stap += 1) {
        const regel = recept[stap % recept.length];
        const eersteRonde = stap < recept.length;

        // Een aangevinkte soort komt er hoe dan ook in, ook als het budget daarmee
        // overschreden wordt: wie erom vraagt hoort hem te krijgen.
        const moet = regel.verplicht && eersteRonde;
        if (!moet && totaal >= cents * 0.85) break;

        const prints = items.filter((it) => this.isPrint(it)).length;
        const opties = groep.filter((p) => {
          if (!regel.test(p) || gebruikt.has(p.id)) return false;

          // Een printje als accent: het eerste stuk is er een, daarna alleen effen.
          if (this.answers.style === 'accent') {
            const print = this.isPrint(p);
            if (print && prints >= 1) return false;
            if (!print && items.length === 0) return false;
          }
          // Hooguit twee van hetzelfde soort, anders krijg je drie mutsjes.
          const zelfde = items.filter((it) => it.type && it.type === p.type).length;
          return zelfde < 2;
        });
        if (opties.length === 0) continue;

        // Alleen wat er nog bij kan. Eerst filteren en dan kiezen, want andersom stopt
        // de hele opbouw zodra het duurste stuk van deze soort niet meer past, terwijl
        // er van een volgende soort nog best iets bij kon.
        const past = opties.filter((p) => (
          moet || items.length < 2 || totaal + p.prijs <= cents * 1.22
        ));
        if (past.length === 0) continue;

        const ruimte = cents - totaal;
        // Zolang er nog niet genoeg in zit mag een product niet het hele budget opeten;
        // pas als het pakket bijna vol is telt alleen nog wat er overblijft.
        const doel = items.length < 2 ? Math.min(ruimte, cents / 2) : ruimte;
        const keus = past.reduce((beste, p) => (
          Math.abs(p.prijs - doel) < Math.abs(beste.prijs - doel) ? p : beste
        ), past[0]);

        gebruikt.add(keus.id);
        items.push(keus);
        totaal += keus.prijs;
      }

      // Vraagt de bezoeker om één soort, dan is één product een geldig antwoord. In alle
      // andere gevallen is een pakket van één stuk geen pakket.
      const minimum = recept.length === 1 && recept[0].verplicht ? 1 : 2;
      if (items.length < minimum) return null;

      // Alles wat de bezoeker aanvinkte hoort erin te zitten. Lukt dat niet binnen deze
      // groep, dan is dit geen bruikbaar pakket en probeert stelSamen het breder.
      // Bij een accent hoort er ook echt iets met een printje in te zitten.
      if (this.answers.style === 'accent' && !items.some((it) => this.isPrint(it))) return null;

      const compleet = recept
        .filter((regel) => regel.verplicht)
        .every((regel) => items.some((it) => regel.test(it)));
      if (!compleet) return null;

      return { items, totaal };
    }

    /**
     * Zet één samengesteld pakket in de opmaak van de kaart.
     * @param {object} pakket - Package with items and total.
     * @returns {Element}
     */
    maakKaart(pakket) {
      const kaart = this.cardTemplate.content.firstElementChild.cloneNode(true);
      const naam = GiftFinder.naamVoor(pakket.items);

      kaart.dataset.name = naam;
      kaart.dataset.total = String(pakket.totaal);
      kaart.querySelector('.gf-card__title').textContent = naam;
      kaart.querySelector('.gf-card__pick-text b').textContent = naam;
      kaart.querySelector('.gf-card__pick-text span').textContent = GiftFinder.money(pakket.totaal);

      const thumbs = kaart.querySelector('.gf-card__thumbs');
      const lijst = kaart.querySelector('.gf-items');

      pakket.items.forEach((product) => {
        const mini = document.createElement('img');
        mini.src = product.img;
        mini.alt = '';
        mini.loading = 'lazy';
        thumbs.appendChild(mini);

        const rij = this.itemTemplate.content.firstElementChild.cloneNode(true);
        rij.querySelector('a').href = product.url;
        rij.querySelector('.js-gf-item-title').textContent = product.titel;
        rij.querySelector('.js-gf-item-type').textContent = product.type;
        rij.querySelector('.gf-item__img').src = product.img;
        rij.dataset.variants = product.varianten
          .map((v) => `${v.size}:${v.id}:${v.price}:${v.available ? '1' : '0'}`)
          .join('|');
        const eerste = product.varianten.find((v) => v.available) || product.varianten[0];
        rij.dataset.default = `${eerste.id}:${eerste.price}`;
        lijst.appendChild(rij);
      });

      this.cardWrap.appendChild(kaart);
      return kaart;
    }

    /**
     * Noemt een pakket naar wat erin zit, want zonder vaste pakketten is er geen naam die
     * de winkelier zelf heeft bedacht.
     * @param {Array} items - Products in the package.
     * @returns {string}
     */
    static naamVoor(items) {
      // Soorten ontdubbelen, anders heet een pakket "boxpakjes met boxpakjes". Bij meer
      // dan drie soorten stopt de opsomming, want de lijst eronder vertelt de rest al.
      const soorten = [];
      items.forEach((p) => {
        const woord = (p.type || p.titel.split(' ')[0]).toLowerCase();
        if (!soorten.includes(woord)) soorten.push(woord);
      });

      const kop = (woord) => woord.charAt(0).toUpperCase() + woord.slice(1);
      if (soorten.length === 1) return kop(soorten[0]);
      if (soorten.length === 2) return `${kop(soorten[0])} met ${soorten[1]}`;

      const eerste = soorten.slice(0, 3);
      if (soorten.length > 3) return `${kop(eerste[0])}, ${eerste[1]}, ${eerste[2]} en meer`;
      return `${kop(eerste[0])}, ${eerste[1]} en ${eerste[2]}`;
    }

    /**
     * De alternatieven hangen binnen de kaart van het voorstel, dus een gewone
     * querySelectorAll pakt hun productregels ook mee. Dit levert alleen de regels van de
     * kaart zelf.
     * @param {Element} card - Package element.
     * @returns {Array}
     */
    static rowsOf(card) {
      return Array.from(card.querySelectorAll('.js-gf-item'))
        .filter((row) => row.closest('.gf-card') === card);
    }

    /**
     * Zet achter elke productregel de maten die dat product zelf heeft.
     * @param {Element} card - The package on top.
     */
    buildSizes(card) {
      GiftFinder.rowsOf(card).forEach((item) => {
        const slot = item.querySelector('.js-gf-item-sizes');
        if (!slot) return;

        const variants = GiftFinder.variantsOf(item);
        if (variants.length === 0 || !variants[0].size) {
          slot.innerHTML = '';
          return;
        }

        const gekozen = String(this.pickVariant(variants, item.dataset.chosen));
        item.dataset.chosen = gekozen;

        const stempel = `${item.dataset.variants}|${gekozen}`;
        if (slot.dataset.built === stempel) return;
        slot.dataset.built = stempel;

        slot.innerHTML = `<span class="gf-item__sizes-label">${this.dataset.sizeLabel || ''}</span>`;
        variants.forEach((v) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'gf-chip gf-chip--sm';
          btn.dataset.variant = String(v.id);
          btn.setAttribute('aria-pressed', String(String(v.id) === gekozen));
          btn.textContent = v.size;
          if (!v.available) {
            btn.disabled = true;
            btn.title = this.dataset.soldoutText || '';
          }
          slot.appendChild(btn);
        });
      });

      this.applySizes();
    }

    /**
     * Reads the variants stored on one product row.
     * @param {Element} item - Product row.
     * @returns {Array}
     */
    static variantsOf(item) {
      return (item.dataset.variants || '')
        .split('|')
        .filter(Boolean)
        .map((part) => {
          const [size, id, price, ok] = part.split(':');
          return {
            size, id: Number(id), price: Number(price), available: ok !== '0', nummer: parseInt(size, 10) || 0
          };
        });
    }

    /**
     * Kiest de maat die hoort bij het antwoord op stap 1. Wie zegt dat de baby er over
     * een paar maanden is, krijgt een maat groter: pasgeborenkleding wordt door iedereen
     * gegeven en is er dan al genoeg. Een eigen keuze gaat voor, zolang die te koop is.
     * @param {Array} variants - Variants of one product.
     * @param {string} eerder - Variant the visitor picked before, if any.
     * @returns {number}
     */
    pickVariant(variants, eerder) {
      const eigen = variants.find((v) => String(v.id) === eerder && v.available);
      if (eigen) return eigen.id;

      const knop = this.querySelector('.gf-step[data-q="when"] [aria-pressed="true"]');
      const doel = knop ? Number(knop.dataset.size) : 0;
      const koopbaar = variants.filter((v) => v.available);
      const pool = koopbaar.length > 0 ? koopbaar : variants;

      if (!doel) return pool[0].id;

      return pool.reduce((beste, v) => {
        const verschil = Math.abs(v.nummer - doel) - Math.abs(beste.nummer - doel);
        if (verschil < 0) return v;
        // Even ver weg: dan de grotere maat, want daar groeit een baby nog in.
        if (verschil === 0 && v.nummer > beste.nummer) return v;
        return beste;
      }, pool[0]).id;
    }

    /**
     * Rekent het pakket door met de maten die per regel gekozen zijn.
     */
    applySizes() {
      const card = this.querySelector('.gf-card.is-main');
      if (!card) return;

      let total = 0;
      const items = [];

      GiftFinder.rowsOf(card).forEach((item) => {
        const variants = GiftFinder.variantsOf(item);
        const [defId, defPrice] = (item.dataset.default || '').split(':');
        let id = Number(defId);
        let price = Number(defPrice);

        const gekozen = variants.find((v) => String(v.id) === item.dataset.chosen);
        if (gekozen) {
          id = gekozen.id;
          price = gekozen.price;
        }

        const priceEl = item.querySelector('.js-gf-item-price');
        if (priceEl) priceEl.textContent = GiftFinder.money(price);

        total += price;
        items.push(`${id}:1`);
      });

      card.dataset.items = items.join(',');
      card.dataset.total = String(total);

      const totalEl = card.querySelector('.js-gf-total');
      if (totalEl) {
        totalEl.dataset.base = String(total);
        const wrapPrice = this.wrapOn() ? Number(this.dataset.wrapPrice || 0) : 0;
        totalEl.textContent = GiftFinder.money(total + wrapPrice);
      }
    }

    /**
     * @returns {boolean} Whether gift wrapping is switched on.
     */
    wrapOn() {
      return Boolean(this.wrapToggle && this.wrapToggle.checked && this.dataset.wrapVariant);
    }

    /**
     * Formats an amount in cents, using the shop's own money format where available.
     * @param {number} cents - Amount in cents.
     * @param {boolean} decimals - Whether to show cents.
     * @returns {string}
     */
    static money(cents, decimals = true) {
      const value = cents / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'nl', {
          style: 'currency',
          currency: (window.theme && theme.currencyCode) || 'EUR',
          minimumFractionDigits: decimals ? 2 : 0,
          maximumFractionDigits: decimals ? 2 : 0
        }).format(value);
      } catch (error) {
        return `€${value.toFixed(decimals ? 2 : 0)}`;
      }
    }

    /**
     * Adds every product in a package to the cart in one request.
     * @param {Element} btn - Button that was clicked.
     */
    async addPackage(btn) {
      if (btn.getAttribute('aria-disabled') === 'true') return;

      const card = btn.closest('.js-gf-card');
      const items = GiftFinder.parseItems(card.dataset.items, card.dataset.name);
      if (items.length === 0) return;

      const noteInput = this.wrapNote ? this.wrapNote.querySelector('.js-gf-note-text') : null;
      const cardText = noteInput ? noteInput.value.trim() : '';

      if (this.wrapOn()) {
        const properties = {};
        if (cardText !== '') properties[this.dataset.noteLabel || 'Kaarttekst'] = cardText;
        items.push({ id: Number(this.dataset.wrapVariant), quantity: 1, properties });
      }

      // De kaarttekst hoort bij de bestelling en niet bij één regel, dus die gaat als
      // attribuut mee. Hij komt in de admin onder Aanvullende details te staan.
      const attributes = {};
      if (cardText !== '') attributes[this.dataset.noteLabel || 'Kaarttekst'] = cardText;

      this.setError('');
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('is-loading');

      try {
        const response = await fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });

        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || response.status);

        if (Object.keys(attributes).length > 0) {
          await fetch(`${theme.routes.cart}/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes })
          });
        }

        btn.classList.add('is-success');

        this.dispatchEvent(new CustomEvent('on:gift-finder:added', {
          bubbles: true,
          detail: { packageName: card.dataset.name, items, attributes }
        }));

        if (theme.settings.cartType === 'drawer') {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        } else {
          window.location.href = theme.routes.cart;
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.setError(theme.strings.cartError);
      } finally {
        btn.removeAttribute('aria-disabled');
        setTimeout(() => {
          btn.classList.remove('is-loading');
          btn.classList.remove('is-success');
        }, 1400);
      }
    }

    /**
     * Turns the "variantId:quantity,variantId:quantity" attribute into cart line items.
     * @param {string} value - Serialised items.
     * @param {string} packageName - Name of the package, stored on each line.
     * @returns {Array}
     */
    static parseItems(value, packageName) {
      if (!value) return [];

      return value.split(',').reduce((items, pair) => {
        const [id, quantity] = pair.split(':');
        if (id) {
          items.push({
            id: Number(id),
            quantity: Number(quantity) || 1,
            properties: { _kraampakket: packageName }
          });
        }
        return items;
      }, []);
    }

    /**
     * Shows or clears the error message.
     * @param {string} text - Message to show.
     */
    setError(text) {
      if (!this.error) return;
      this.error.textContent = text;
      this.error.hidden = text === '';
    }
  }

  customElements.define('gift-finder', GiftFinder);
}
